// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + {"1520":"dcda178ee05a7526d5c1","7533":"f5928c6a4e2a363b14c6"}[chunkId] + "";
};